import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ChoThue } from "./ChoThue";

export const BtnChoThue = ({ TaiSanID, trangthai }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <a onClick={handleShow} href={() => false}>
        <PopoversBootrap
          contentText="Cho thuê"
          trigger={["hover", "focus"]}
          placement={"top"}
        >
           <img src="/app-assets/images/icon-cho-thue-v2.png" />
        </PopoversBootrap>
      </a>
      {show && (
        <ChoThue
          show={show}
          onHide={handleClose}
          TaiSanID={TaiSanID}
          trangthai={trangthai}
        />
      )}
    </>
  );
};
